const coFTargetElement = document.querySelector('.co-footer-top-klaviyo-embed>div>div');
const coFLoaderElement = document.querySelector('.co-footer-top-klaviyo-embed-loading');
const coFEmbedElement = document.querySelector('.co-footer-top-klaviyo-embed');
const coFObserverCallback = function(mutationsList, coFObserver) {
    for (let mutation of mutationsList) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            yourActionFunction();
            coFObserver.disconnect();
        }
    }
};
const coFObserver = new MutationObserver(coFObserverCallback);
coFObserver.observe(coFTargetElement, { childList: true });
function yourActionFunction() {
    coFLoaderElement.classList.add('co-loaded');
    coFEmbedElement.classList.add('co-loaded');
}
// capitilize
// function coTitleCase(str) {
//   const skip = ['of','and','the','in','on','at','to','for','by','it'];
//   return str
//     .toLowerCase()
//     .split(' ')
//     .map((word, i) => {
//       if (i !== 0 && skip.includes(word)) return word;
//       return word.charAt(0).toUpperCase() + word.slice(1);
//     })
//     .join(' ');
// }
// document.querySelectorAll('.footer__copyright .policies a').forEach(el => {
//   el.textContent = coTitleCase(el.textContent);
// });